<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="page_xv"></a> </p>
<p class="noindent1"> </p>
<p class="noindent1"> </p>
<p class="noindent1"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="HTitle">RAILROADS AND THE AMERICAN PEOPLE</p></td>
<td valign="top"><p class="right"><img alt="image" src="images/common-right.jpg"/><a id="page_xvi"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?2789029b